export const typography = {
  htmlFontSize: 16,
  fontSize: 14,
  fontFamily: [
    "Asap",
    "Almarai",
    "sans-serif",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontSize: "24px", // 60px
    fontWeight: 600,
    lineHeight: 2, // 32px
    letterSpacing: -0.5,
  },
  h2: {
    fontSize: "20px", // 24px
    fontWeight: 600,
    lineHeight: 1.334, // 21.344px
    letterSpacing: 0.15,
  },
  h3: {
    fontSize: "16px", // 16px
    fontWeight: 600,
    lineHeight: 1.167, // 18.672px
    letterSpacing: 0.25,
  },
  h4: {
    fontSize: "14px", // 24px
    fontWeight: 400,
    lineHeight: 1.235, // 19.76px
    letterSpacing: 0,
  },
  h5: {
    fontSize: "12px", // 16px
    fontWeight: 400,
    lineHeight: 1.334, // 21.344px
    letterSpacing: 0.15,
  },
  h6: {
    fontSize: "1.25rem", // 20px
    fontWeight: 600,
    lineHeight: 1.6, // 25.6px
    letterSpacing: 0,
  },
  subtitle1: {
    fontSize: "1.125rem", // 18px
    fontWeight: 400,
    lineHeight: 1.25, // 20px
    letterSpacing: 0.15,
  },
  subtitle2: {
    fontSize: "1rem", // 16px
    fontWeight: 400,
    lineHeight: 1.25, // 20px
    letterSpacing: 0.1,
  },
  body1: {
    fontSize: "1rem", // 16px
    fontWeight: 400,
    lineHeight: 1.5, // 24px
    letterSpacing: 0,
  },
  body2: {
    fontSize: "14px", // 14px
    fontWeight: 400,
    lineHeight: "1.5", // 21px
    letterSpacing: 0.25,
  },
  button: {
    fontSize: "0.875rem", // 14px
    fontWeight: 600,
    lineHeight: 1, // 16px
    letterSpacing: 1.25,
    textTransform: "uppercase" as const,
  },
  caption: {
    fontSize: "0.75rem", // 12px
    fontWeight: 400,
    lineHeight: "1.5rem", // 24px
    letterSpacing: 0,
  },
  overline: {
    fontSize: "0.625rem", // 10px
    fontWeight: 400,
    lineHeight: "0.75rem", // 12px
    letterSpacing: 1.5,
    textTransform: "uppercase" as const,
  },
};
